module.exports = __webpack_public_path__ + "fonts/MicrogrammaD-MediExte.e94608d.eot";